import React, { useRef, useState, useEffect } from "react";
import "./youtubeEmbed.scss";
import { PlayIcon } from "../../assets/Icons";
import { useWindowSize } from "react-use";

const YoutubeEmbed = ({
  videoId,
  thumbnail,
  mobileThumbnail,
  iconcss,
  mobileAutoPlay = false,
  showHoverAnimation = false,
  iframecss,
  mobileAutoplayOnCenter,
}) => {
  const { width } = useWindowSize();
  const [isHovered, setIsHovered] = useState(false);
  const [shouldPlay, setShouldPlay] = useState(false);
  const containerRef = useRef(null);
  const timerRef = useRef(null);
  const isMobile = width <= 992;

  useEffect(() => {
    if (isMobile) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            timerRef.current = setTimeout(() => {
              setShouldPlay(true);
            }, 1000);
          } else {
            clearTimeout(timerRef.current);
            setShouldPlay(false);
          }
        },
        {
          threshold: 0.5,
        }
      );

      if (containerRef.current) {
        observer.observe(containerRef.current);
      }

      return () => {
        observer.disconnect();
        clearTimeout(timerRef.current);
      };
    }
  }, [isMobile]);

  const youtubeFrame = () => (
    <iframe
      className={`${iframecss}`}
      src={`https://www.youtube.com/embed/${videoId}?playlist=${videoId}&rel=0&autoplay=1&mute=1&loop=1&controls=0`}
      title="YouTube video"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullScreen
      style={{ pointerEvents: "none" }}
    />
  );

  return (
    <div
      className="w-full h-full relative"
      onMouseEnter={() => !isMobile && setIsHovered(true)}
      onMouseLeave={() => !isMobile && setIsHovered(false)}
      ref={containerRef}
    >
      {isMobile ? (
        shouldPlay ? (
          youtubeFrame()
        ) : (
          <div className="h-full w-full cursor-pointer relative">
            <img
              src={isMobile && mobileThumbnail ? mobileThumbnail : thumbnail}
              alt="Youtube Thumbnail"
              className="h-full w-full object-cover object-center"
            />
            <img
              src={PlayIcon}
              alt="Play Icon"
              className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${iconcss}`}
            />
          </div>
        )
      ) : isHovered ? (
        youtubeFrame()
      ) : (
        <div className="h-full w-full cursor-pointer relative">
          <img
            src={isMobile && mobileThumbnail ? mobileThumbnail : thumbnail}
            alt="Youtube Thumbnail"
            className="h-full w-full object-cover"
            // className="w-full h-full object-contain object-right-top"
            // className="w-full object-contain"
          />
          <img
            src={PlayIcon}
            alt="Play Icon"
            className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${iconcss}`}
          />
        </div>
      )}
    </div>
  );
};

export default YoutubeEmbed;
